<template>
  
    <el-container>
     
      <el-main>
       <h1>创建 rich 模式的思维导图</h1>
       <h2>方法 1</h2>
       <p>在markdown 文件中添加 yaml :</p>
       <pre>
        <code>
---

mindmap-plugin: rich

---
        </code>
       </pre>
       <p>在更多菜单中找到 <i>打开为思维导图</i></p>
       <div>
         <img src="../assets/markmind/rich.gif" alt="" width="800">
       </div>

       <h2>方法 2</h2>
       <p>在设置页面修改 <i>思维导图模式</i>  从  <code>basic</code> 修改为 <code>rich</code></p>
       <p>在文件夹上右击，点击 <i>创建思维导图</i>菜单</p>
      
       <div>
          <img src="../assets/markmind/richsetup.gif" alt="" width="800">
       </div>
       <div>
           <img src="../assets/markmind/richsetup2.gif" alt="" width="800">
       </div>

       <h3>如何导出思维导图为图片？</h3>

       <p>使用 ctrl + p ,执行 <i>导出思维导图为html</i>命令，注意思维导图中的图片只支持本地图片，原因是为了安全，不支持跨域</p>

      </el-main>
    </el-container>
 
</template>

<script>
export default {
  name: 'RichModePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
